/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_SubmitInputs */

const en_feedback_submit = /** @type {(inputs: Feedback_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send feedback`)
};

const id_feedback_submit = /** @type {(inputs: Feedback_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kirim masukan`)
};

/**
* | output |
* | --- |
* | "Send feedback" |
*
* @param {Feedback_SubmitInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const feedback_submit = /** @type {((inputs?: Feedback_SubmitInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_SubmitInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_feedback_submit(inputs)
	return en_feedback_submit(inputs)
});